import { render } from "./AlertError.vue?vue&type=template&id=52803174&scoped=true&ts=true"
import script from "./AlertError.vue?vue&type=script&lang=ts"
export * from "./AlertError.vue?vue&type=script&lang=ts"

import "./AlertError.vue?vue&type=style&index=0&id=52803174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52803174"]])

export default __exports__